import statuses from 'statuses';
/**
 * @ngdoc service
 * @name apiVersionInterceptor
 * @description
 * It checks if the API responds with a `409`, which means that the backend is running on a
 * different version and the app needs to be updated.
 *
 * @memberof rootModule
 */
class APIVersionInterceptor {
  /**
   * Class constructor.
   * @param {Service} $q         To return an already rejected promise.
   * @param {Service} appUpdates To inform the app of the `409`.
   *
   * @ignore
   */
  constructor($q, appUpdates) {
    'ngInject';

    /**
     * The local reference to the `$q` service.
     * @type {Object}
     */
    this.$q = $q;
    /**
     * The local reference to the `appUpdates` service.
     * @type {Object}
     */
    this.appUpdates = appUpdates;
    /**
     * @ignore
     */
    this.responseError = this.responseError.bind(this);
  }
  /**
   * This method gets executed after a failed request, it checks if the response status is `409`
   * and informs the service that handles the update.
   * @param {Object} response The request response.
   * @return {Promise} An already rejected promise.
   */
  responseError(response) {
    if (response.status === statuses.conflict) {
      this.appUpdates.theAppNeedsToBeUpdated();
    }

    return this.$q.reject(response);
  }
}

export default APIVersionInterceptor;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/services/apiVersionInterceptor.js